import { exportViewBox } from './svg';
import { pdfPagePlan } from './pdf';
import { rasterSizeFor, MAX_RASTER_EDGE } from './raster-size';
/** Runs before creating a bitmap or loading PDF fonts. Uses the exporter's actual page plan. */
export function exportPreflight(scene, scale, pagination = { mode: 'fit' }, maxEdge = MAX_RASTER_EDGE) {
    const view = exportViewBox(scene.bounds);
    const raster = rasterSizeFor(view.width, view.height, scale, maxEdge);
    let pages = 0;
    let pdfScale = 0;
    let pdfError = '';
    try {
        const plan = pdfPagePlan(view, { pagination });
        pages = plan.length;
        pdfScale = plan[0]?.scale ?? 0;
    }
    catch {
        pdfError = 'PDF limitado a 100 páginas. Use uma página ou exporte ramos separados.';
    }
    return {
        raster,
        bitmapMiB: Math.ceil((raster.width * raster.height * 4) / 1024 / 1024),
        largeImage: raster.width * raster.height > 8_000_000,
        pages,
        pdfScale,
        smallText: pdfScale < 0.5,
        pdfError,
    };
}
//# sourceMappingURL=preflight.js.map